export default __webpack_public_path__ + "static/media/SWT0540.34I-20638_-22460_0.ad82f4b9.jpg";